import { Controller } from "@hotwired/stimulus";

// controller to resize input fields in the feed, for example comment input and post input

export default class extends Controller {
  static targets = ["textContent", "expandButton"];
  static values = {
    clampHeight: { type: Number, default: 64 },  // Default: 3 lines in pixels
    clampRem: { type: Number, default: 4 }       // Default: 3 lines in rem
  }

  connect() {
    this.expanded = false;
    this.checkIfClampingNeeded();
  }

  checkIfClampingNeeded() {
    const content = this.textContentTarget;
    const clampedHeight = this.clampHeightValue;

    // Temporarily remove clamped class to get true scrollHeight
    content.classList.remove("clamped");
    content.style.maxHeight = 'none';

    const needsClamping = content.scrollHeight > clampedHeight;

    if (needsClamping) {
      content.classList.add("clamped");
      content.style.maxHeight = `${this.clampRemValue}rem`;
      this.expandButtonTarget.style.display = "block";
    } else {
      this.expandButtonTarget.style.display = "none";
    }
  }

  toggle() {
    this.expanded = !this.expanded;
    const content = this.textContentTarget;

    if (this.expanded) {
      content.classList.remove("clamped");
      content.style.maxHeight = content.scrollHeight + "px";
      this.expandButtonTarget.textContent =
        this.expandButtonTarget.dataset.seeLessText || "...see less";
    } else {
      content.classList.remove("clamped");
      content.style.maxHeight = content.scrollHeight + "px";
      content.offsetHeight;
      requestAnimationFrame(() => {
        content.style.maxHeight = `${this.clampRemValue}rem`;
      });
      this.expandButtonTarget.textContent =
        this.expandButtonTarget.dataset.seeMoreText || "...see more";
      content.addEventListener(
        "transitionend",
        () => {
          content.classList.add("clamped");
        },
        { once: true }
      );
    }
  }
}
